import { getSearchProducts as getSearchProductsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import type {
  SearchProductsServiceRequest,
  SearchProductsServiceResponse,
} from './search-products.dto';
import {
  SearchProductsServiceRequestDtoSchema,
  SearchProductsServiceResponseDtoSchema,
} from './search-products.dto';

export const searchProductsService = withServiceErrorCapture(
  lazyPipe(
    // 1. Validate the incoming request object against a Zod schema.
    validateServiceRequest(SearchProductsServiceRequestDtoSchema),

    // 2. Execute the core business logic.
    async (request: SearchProductsServiceRequest): Promise<SearchProductsServiceResponse> => {
      // API Layer 호출
      const apiResponse = await getSearchProductsApi(request);

      // 다음 페이지 존재 여부 확인 (link.next 값 기준)
      const hasNextPage = apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const nextPage = hasNextPage ? request.page + 1 : undefined;

      // 데이터 변환 및 비즈니스 로직 처리
      const transformedList = apiResponse.data.list.map((product) => ({
        ...product,
        goodsNo: product.goodsNo.toString(),
        isExclusive: product.isExclusive ?? false,
        hasNextPage,
        nextPage,
      }));

      const response: SearchProductsServiceResponse = {
        total:
          apiResponse.link && 'total' in apiResponse.link
            ? ((apiResponse.link as { total: number | null }).total ?? 0)
            : 0,
        list: transformedList,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage,
        },
      };

      return response;
    },

    // 3. Validate the final response object before it is returned.
    validateServiceResponse(SearchProductsServiceResponseDtoSchema),
  ),
);
